import { createSlice } from "@reduxjs/toolkit";
import { getOrderSources, getAllOrderSources } from "./orderSourcesAction";
import { logOut } from "../auth/authSlice";
import { userLogin, demoLogin } from "../auth/authActions";

const initialState = {
  items: [],
  loading: false,
  error: null,
  all: {
    items: [],
    loading: false,
    error: null,
  },
};

// Until the endpoint is deployed the server answers with a redirect to an HTML
// page (200), which must not end up in the option lists.
const toItems = (payload) => (Array.isArray(payload) ? payload : []);

const orderSourcesSlice = createSlice({
  name: "orderSources",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOrderSources.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOrderSources.fulfilled, (state, action) => {
        state.items = toItems(action.payload);
        state.loading = false;
      })
      .addCase(getOrderSources.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getAllOrderSources.pending, (state) => {
        state.all.loading = true;
        state.all.error = null;
      })
      .addCase(getAllOrderSources.fulfilled, (state, action) => {
        state.all.items = toItems(action.payload);
        state.all.loading = false;
      })
      .addCase(getAllOrderSources.rejected, (state, action) => {
        state.all.loading = false;
        state.all.error = action.payload;
      })
      // The list is per organization: drop it so the next account re-fetches.
      .addCase(logOut, () => initialState)
      .addCase(userLogin.fulfilled, () => initialState)
      .addCase(demoLogin.fulfilled, () => initialState);
  },
});

export default orderSourcesSlice.reducer;
